export default {
	isAuthenticated(state) {
		return !!state.token;
	},
	allUsers(state) {
		return state.usersList;
	},
	userId(state) {
		return state.userId;
	},
	userEmail(state) {
		return state.email;
	},
	userFName(state) {
		return state.firstName;
	},
	userLName(state) {
		return state.lastName;
	},
	userType(state) {
		return state.userType;
	},
	userTeam(state) {
		return state.team;
	},
	userTeamId(state) {
		return state.teamId;
	},
	userLeague(state) {
		return state.league;
	},
	userLeagueId(state) {
		return state.leagueId;
	},
	userDivisionId(state) {
		return state.divisionId;
	},
	userDivision(state) {
		return state.division;
	},
	getUpdateComponent(state) {
		return state.updateComponent;
	},
	didAutoLogout(state) {
		return state.didAutoLogout;
	},
};
